import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, Event } from '@angular/router';
import { JobDetailsComponent } from './common/job-details/job-details.component';
import { JobDetailsService } from './service/job-details.service';
import { MatSpinner } from '@angular/material';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { SampleService } from './service/sample.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  title = 'ameria';
  currentLang = 'am';
  jobDetails: any;
  id: string;
  showLoadingIndicator = true;
  hostName: string;
  IEVersion;
  isIE;
  isJobDetailsPage = false;
  public matSpinner = MatSpinner;
  constructor(private translate: TranslateService,
              private route: ActivatedRoute,
              private location: Location,
              private router: Router,
              private jobDetailsService: JobDetailsService,
              private spinner: SpinnerVisibilityService,
              private sampleService: SampleService) {
    // spinner.show();
    // this.router.events.subscribe((routerEvent: Event) => {
    //   if (routerEvent instanceof NavigationStart) {
    //     this.showLoadingIndicator = true;
    //   }
    //   if (routerEvent instanceof NavigationEnd ||
    //     routerEvent instanceof NavigationError ||
    //     routerEvent instanceof NavigationCancel) {
    //     this.showLoadingIndicator = false;
    //   }
    // });

    this.hostName = this.sampleService.getHostname();
    if (this.hostName.includes('ameriabank.am')) {
        localStorage.setItem('companyId', '1');
    } else if (this.hostName.includes('amerialegal.am')) {
      localStorage.setItem('companyId', '2');
    } else {
      localStorage.setItem('companyId', '1');
    }
  }

  switchLanguage(language: string) {
    window.location.reload();
    this.currentLang = language;
    this.translate.use(this.currentLang);
    localStorage.setItem('lang', this.currentLang);
  }

  getCurrentUrl() {
    if (this.router.url.includes('job-details')) {
      this.isJobDetailsPage = true;
    }
  }

  ngOnInit() {
    setTimeout(() =>
      this.getCurrentUrl()
    );
    // if (this.router.url.includes('en')) {
    //     localStorage.setItem('lang', 'en');
    //     this.translate.use('en');
    //     this.currentLang = 'en';
    //     alert();
    // } else if (this.router.url.includes('ru')) {
    //     localStorage.setItem('lang', 'ru');
    //     this.translate.use('ru');
    //     this.currentLang = 'ru';
    // }  else if (this.router.url.includes('am')) {
    //   localStorage.setItem('lang', 'am');
    //   this.translate.use('am');
    //   this.currentLang = 'am';
    // }

    function detectIE() {
      const ua = window.navigator.userAgent;
      const msie = ua.indexOf('MSIE ');
      if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
      }
      const trident = ua.indexOf('Trident/');
      if (trident > 0) {
        // IE 11 => return version number
        const rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
      }
      // other browser
      return false;
    }

    this.isIE = detectIE();

    if (localStorage.getItem('lang')) {
        this.currentLang = localStorage.getItem('lang');
    } else {
        this.currentLang = 'am';
        localStorage.setItem('lang', this.currentLang);
    }
    this.translate.use(this.currentLang);
  }
}
